import React from 'react';
import { HoverAccentButton, MultilineInput, UserImage } from '@lyearn-team/frontend-components';
import { withTheme } from 'emotion-theming';
import { observer, inject } from 'mobx-react';
import { Keys } from 'components/LiveClass/utils/consts';
import * as s from './styles';

@withTheme
@inject(stores => ({ model: stores.liveClassModel }))
@observer
class Footer extends React.Component {
  state = { chatMessage: '' };

  handleInputChange = (e) => {
    this.setState({ chatMessage: e.currentTarget.value });
  };

  handleKeyDown = (e) => {
    if (!this.props.model.store.isMobile && e.keyCode === Keys.Enter && !e.shiftKey) {
      e.preventDefault();
      this.handleSend();
    }
  };

  handleSend = () => {
    const { handleSendMessage } = this.props.model.store.activity;
    handleSendMessage(this.state.chatMessage.trim());
    this.setState({ chatMessage: '' });
  };

  render() {
    const { theme, model } = this.props;
    const { currentUser } = model.store.activity;
    const { name, picture } = currentUser;
    const text = this.state.chatMessage;

    return (
      <footer className={s.activityFooter}>
        <UserImage name={name} url={picture} />
        <MultilineInput
          value={text}
          onChange={this.handleInputChange}
          onKeyDown={this.handleKeyDown}
          ref={this.textAreaRef}
          className={s.textArea(theme)}
          autosize={true}
        />
        <HoverAccentButton
          className={s.sendButton(theme)}
          icon={{ type: 'send' }}
          disabled={!text.trim()}
          onClick={this.handleSend}
        />
      </footer>
    );
  }
}

export default Footer;
